import React, {useContext} from "react";
import PageTitle from "../../../layout/PageTitle";
import {useQuery} from "@apollo/client";
import {getClientsQuery} from "./ClientQueries";
import {tableImageTag} from "../../../helpers/Api";
import {AddButton, ViewButton} from "../../../helpers/ButtonHelper";
import ListTable from "../../shared/ListTable";
import {UserContext} from "../../../context/UserContext";
import {Link} from "react-router-dom";

const ClientsList = () => {
  const {data} = useQuery(getClientsQuery, {fetchPolicy: 'network-only'})
  const {plan: {usersLimit, usersCount}} = useContext(UserContext)

  const header = <tr>
    <th>Nume</th>
    <th>Email</th>
    <th>Telefon</th>
    <th># Meniuri</th>
    <th className='actions'></th>
  </tr>

  const listItem = (item, index) => {
    return <tr key={index}>
      <td>
        <Link to={`/clients/${item.id}`}>
          {tableImageTag(item, {type: 'avatar', src: item.avatar})}
          {item.fullName}
        </Link>
      </td>
      <td>{item.email}</td>
      <td>{item.phone}</td>
      <td>{item.menusCount}</td>
      <td className='actions'>
        <ViewButton to={`/clients/${item.id}`}/>
      </td>
    </tr>
  }

  return (
    <div className="container">
      <PageTitle title='Clienti' buttons={usersLimit > usersCount &&
        <AddButton to='/clients/new' text='Invita un client'/>
      }/>
      <div className="row justify-content-md-center">
        <div className="page-container col">
          <ListTable data={data && data.clients} header={header} listItem={listItem}
                     searchFields={['fullName', 'email', 'phone']}/>
        </div>
      </div>
    </div>
  )
};

export default ClientsList;